import React, { useContext, useEffect, useState } from 'react';
import Betslip from '../../common/Betslip';
import FavoritesContextProvider from '../../common/FavoritesContextProvider';
import Loader from '../../common/Loader';
import Menu from '../../common/menu/Menu';
import LiveContext from '../../contexts/LiveContext';
import MainContext from '../../contexts/MainContext';
import { useFetchLiveMatch } from '../../data/fetchLiveSingleMatchPage';
import { getMatchStreamingProps } from '../../data/streaming/streamingUtils';
import { parseWindowLocationHash } from '../../data/utils';
import MatchSearchPopup from '../../prematch/MatchSearchPopup';
import { initLiveMatchEffects } from '../../sport-effects';
import { setAvailableSpaceForTables } from '../../tables-utils';
import { useLayout } from '../../UISettingsProvider';
import MatchView from './MatchView';

function handleOpenFromHash(liveContext){
    const parsedData =  parseWindowLocationHash(true);

    try {
        if(parsedData && parsedData.isMatch){
            liveContext.changeMatch(parsedData.sportId, parsedData.countryId, parsedData.tournamentId, parsedData.matchId );
        }
    }catch(err){
        console.log(err);
        return null;
    }
    return parsedData &&  parsedData.isMatch;
}

function LiveMatch(props) {
    const layout = useLayout();
    const mainContext = useContext(MainContext);
    const liveContext = useContext(LiveContext);
    // Abilita scrolling
    useEffect(function() {
        window.setHeight();
        setAvailableSpaceForTables();
    });

    const [data, setData] = useState(null);
    const [menuLiveSelectedSports,setMenuLiveSelectedSports] = useState([]);
    const [menuLiveSelectedCountries,setMenuLiveSelectedCountries] = useState([]);
    const [showLoader,setShowLoader] = useState(true);

    useEffect(() => {
        initLiveMatchEffects();
        mainContext.setMatchData(null, true);
        return () => {
            setShowLoader(true);
            liveContext.resetMatch();
        };
    }, []);

    const [request] = useFetchLiveMatch();
    useEffect(function() {
        let timeout = null;
        if (!request.isLoading) {
            setShowLoader(false);
            if (!request.isError) {
                if (request.data) {
                    setData(request.data);
                    liveContext.setData(request.data);
                    const openFromHash = handleOpenFromHash(liveContext);
                    if (!openFromHash && liveContext.currentMatch == null) {
                        try {
                            const matchData = liveContext.matchData;
                            const match = liveContext.currentMatch || (matchData?{sportRef:matchData.sportId,categoryRef:matchData.countryId, tournamentRef: matchData.tournamentId, id: matchData.matchId } :null) || request.data.sport[0].categories[0].tournaments[0].events[0];
                            liveContext.changeMatch(match.sportRef, match.categoryRef, match.tournamentRef, match.id);
                        } catch (e) {
                            console.error(e);
                        }
                    }
                } else {
                    console.error("No data available from server");
                }
            }
        }

        return () => {
            clearInterval(timeout);
        };
    }, [request]);

    const menuLiveTogglers = {
        selectedSports: menuLiveSelectedSports,
        toggleSport: function(sportId) {
            if (!menuLiveSelectedSports.includes(sportId)) {
                setMenuLiveSelectedSports(menuLiveSelectedSports.concat(sportId));
            } else {
                setMenuLiveSelectedSports(menuLiveSelectedSports.filter(e => e !== sportId));
            }
        },
        selectedCountries: menuLiveSelectedCountries,
        toggleCountry: function(countryId) {
            if (!menuLiveSelectedCountries.includes(countryId)) {
                setMenuLiveSelectedCountries(menuLiveSelectedCountries.concat(countryId));
            } else {
                setMenuLiveSelectedCountries(menuLiveSelectedCountries.filter(e => e !== countryId));
            }
        }
    }

    if ((showLoader && request.isLoading) || request.isError) {
        return <Loader error={request.isError} />;
    }

    return (
        <FavoritesContextProvider>
            <div className="container-fluid pagina-sport bg-grigio-chiaro padding-su-1x">
                <div className="row no-gutters sport-griglia">
                    <Menu data={data} isLive={true} menuLiveTogglers={menuLiveTogglers} />
                    {liveContext.currentMatch ?
                        (function() {
                            const streamingMap = getMatchStreamingProps(liveContext.currentMatch);
                            return <MatchView match={liveContext.currentMatch} streaming={streamingMap && streamingMap[liveContext.currentMatch.id]} />
                        }())
                        :
                        <div className={"griglia-centrale-sport col stringimento-sidebar evento-live-centrale d-flex justify-content-between "+ layout.order.divCentrale} id="div-centrale"></div>
                    }
                    <Betslip />
                    <MatchSearchPopup />
                </div>
            </div>
        </FavoritesContextProvider>
    );
}
    
export default LiveMatch;